/**
 * @fileoverview Middleware Redux para persistência automática em dispositivos móveis.
 * Intercepta ações do carrinho e favoritos para salvar automaticamente no localStorage.
 * 
 * @module MobilePersistenceMiddleware
 * @since 1.0.0
 */

import { mobilePersistence } from '../../utils/mobilePersistence.js';

/**
 * Ações que devem disparar persistência automática.
 */
const PERSIST_ACTIONS = [
  'cart/addToCart',
  'cart/updateCartQuantity', 
  'cart/removeFromCart',
  'cart/clearCartWithSync',
  'favorites/toggleFavorite',
  'favorites/clearFavoritesWithSync'
];

/**
 * Middleware para persistência automática em mobile.
 * Salva dados no localStorage após ações específicas.
 * 
 * @param {Object} store - Store Redux
 * @returns {Function} Middleware function
 */
export const mobilePersistenceMiddleware = (store) => (next) => (action) => {
  // Executa a ação primeiro
  const result = next(action);

  // Verifica se deve persistir dados após a ação
  if (PERSIST_ACTIONS.includes(action.type)) {
    const state = store.getState();
    
    // Persiste carrinho se ação relacionada ao carrinho
    if (action.type.startsWith('cart/')) {
      mobilePersistence.saveCart(state.cart.items);
    }
    
    // Persiste favoritos se ação relacionada aos favoritos
    if (action.type.startsWith('favorites/')) {
      mobilePersistence.saveFavorites(state.favorites.items);
    }
  }

  return result;
};

export default mobilePersistenceMiddleware;